// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2X7yO","right":"styles_right__2InvR"};